import { useState, useEffect, useCallback } from 'react';
import {producaov2 } from '../../../services/apis';

export const RESUMOS_FILTERS = {
  SEARCH: 'search' 
};

const buildResumosUrl = ({ baseUrl, page, rowsPerPage, filters }) => {
  const query = {
    page: page + 1, 
    limit: rowsPerPage,
    ...(filters?.[RESUMOS_FILTERS.SEARCH] && { search: filters[RESUMOS_FILTERS.SEARCH] }),
  };

  const queryParams = new URLSearchParams(query);
  return `${baseUrl}?${queryParams.toString()}`;
};

const useResumosDeAula = () => {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentFilters, setCurrentFilters] = useState({}); 

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    const url = buildResumosUrl({
      baseUrl: '/ai/lesson/description',
      page: currentPage,
      rowsPerPage,
      filters: currentFilters
    });
    try {
      const response = await producaov2.get(url);
      setData(response.data || []);
    const total = response.headers?.['x-total-count'] || response.headers?.['X-Total-Count'];
      setTotalRecords(Number(total) || 0);
    } catch (error) {
      console.error("Erro ao buscar resumos de aula:", error);
      setData([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, rowsPerPage, currentFilters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPageValue) => {
    setRowsPerPage(parseInt(newRowsPerPageValue, 10));
    setCurrentPage(0);
  };

  const handleSubmitFilters = (newFilters) => {
    setCurrentFilters(newFilters);
    setCurrentPage(0);
  };

  const handleResetFilters = () => {
    setCurrentFilters({});
    setCurrentPage(0);
  };

  const refreshData = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    totalRecords,
    isLoading,
    currentPage,
    rowsPerPage,
    currentFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleSubmitFilters,
    handleResetFilters,
    refreshData,
  };
};

export default useResumosDeAula;